import { IconSearchStroked } from '@consta/icons/IconSearchStroked'
import { ChoiceGroup } from '@consta/uikit/ChoiceGroup'
import { TextField } from '@consta/uikit/TextField'
import { memo } from 'react'

import type { ItemSwitchViewGroupType } from '../types'
import css from './SortFilter.css'

type PropsType = {
  valueSwitchViewGroup: ItemSwitchViewGroupType
  setValueSwitchViewGroup: (item: ItemSwitchViewGroupType) => void
  itemsSwitchViewGroup: ItemSwitchViewGroupType[]
  setQuery: (value: string) => void
}

const SortFilter = memo<PropsType>(
  ({ valueSwitchViewGroup, setValueSwitchViewGroup, itemsSwitchViewGroup, setQuery }) => {
    return (
      <span className={css.container}>
        <TextField
          leftSide={IconSearchStroked}
          placeholder="Название проекта"
          labelPosition="left"
          size="s"
          onChange={value => {
            setQuery(value ?? '')
          }}
        />
        <ChoiceGroup
          size="s"
          name="switchViewGroup"
          view="ghost"
          onlyIcon={true}
          items={itemsSwitchViewGroup}
          value={valueSwitchViewGroup}
          getItemLabel={item => item.name}
          getItemIcon={item => item.icon}
          multiple={false}
          onChange={setValueSwitchViewGroup}
        />
      </span>
    )
  },
)

SortFilter.displayName = 'SortFilter'

export { SortFilter }
